import {AxiosError} from 'axios';
import {GET_LAST_UPDATED_INFO_QUERY_KEY} from '../../constants/queryKeys';
import {useCustomQuery} from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GET_LAST_UPDATED_INFO_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface lastUpdatedInfoModel {
  lastUpdatedTime: string | null | undefined;
  name: string | null | undefined;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  year: number;
  uuid: string;
  onSuccess?: (data: any) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
}

export const useGetLastUpdatedInfo = ({
                                        year,
                                        uuid,
                                        onSuccess,
                                        onError,
                                        enabled = true,
                                      }: Input) => {
  const getLastUpdatedInfo = async () => {
    const res = await axiosClient.get<lastUpdatedInfoModel>(GET_LAST_UPDATED_INFO_URL(year, uuid));
    return res.data;
  };

  return useCustomQuery(
      [GET_LAST_UPDATED_INFO_QUERY_KEY, uuid, year],
      getLastUpdatedInfo,
      {
        onSuccess,
        onError,
        enabled,
      },
      true,
      false
  );
};
